/**
 * @desc 库存调整单作废
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/invalid`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
